export const PR_PT = 'PR_PT';
export const PR_PPT = 'PR_PPT';
export const FREQUENCY = 'INPUT_MODE';
export const PLAN_OPTION = 'PlanOption';
export const PR_ANNPREM = 'PR_ANNPREM';
export const INCOME_START_YEAR = 'IncomeStartYear';
export const LIFE_COVER_CONTINUATION_BENEFIT = 'LifeCoverContinuationBenefit';
export const PERSONALISED_OPTION = 'PersonalisedOption';
export const WITHDRAWAL = 'PWInterval';
export const WITHDRAWAL_START_YEAR = 'PWStartYear';
export const WITHDRAWAL_STOP_YEAR = 'PWEndYear';
export const AGE_BASED_WITHDRAWAL = 'PWAge';
export const START_AGE = 'PWStartAge';
export const END_AGE = 'PWEndAge';


export const ACCRUALOFSURVIVALBENEFIT_1 = "AccrualOfSurvivalBenefit_1";
export const ASB_STARTPOLICYYEAR_1 = "ASB_StartPolicyYear_1";
export const ASB_ENDPOLICYYEAR_1 = "ASB_EndPolicyYear_1";

export const ACCRUALOFSURVIVALBENEFIT_2 = "AccrualOfSurvivalBenefit_2";
export const ASB_STARTPOLICYYEAR_2 = "ASB_StartPolicyYear_2";
export const ASB_ENDPOLICYYEAR_2 = "ASB_EndPolicyYear_2";

export const ACCRUALOFSURVIVALBENEFIT_3 = "AccrualOfSurvivalBenefit_3";
export const ASB_STARTPOLICYYEAR_3 = "ASB_StartPolicyYear_3";
export const ASB_ENDPOLICYYEAR_3 = "ASB_EndPolicyYear_3";

export const ASB_WITHDRAWALPERCENTAGE_1 = "WithdrawalPercentage_1";
export const ASB_WITHDRAWALPERCENTAGE_2 = "WithdrawalPercentage_2";
export const ASB_WITHDRAWALPERCENTAGE_3 = "WithdrawalPercentage_3";

export const SECOND_LIFE_ASSURED_NAME = 'SecondLifeAssuredName';
export const SECOND_LIFE_ASSURED_FIRST_NAME = 'SecondLifeAssuredFirstName';
export const SECOND_LIFE_ASSURED_LAST_NAME = 'SecondLifeAssuredLastName';
export const SECOND_LIFE_ASSURED_DOB = 'SecondLifeAssuredDOB';

export const SecLaDOB =  'SecLaDOB'

export const SECOND_LIFE_ASSURED_GENDER = 'SecondLifeAssuredGender';

export const WOP_RIDER = 'WaiverOfPremiumRider';
export const ADB_RIDER = 'ADBRider';
export const ATPD_RIDER = 'ATPDRider';
export const Critical_ILLNESS_RIDER = 'CriticalIllnessRider';
export const INCOME_BENEFIT_RIDER = 'IncomeBenefitRider';
export const PWB_RIDER = 'PayorWaiverBenefitRider';
export const PWB = "PWB";

